import apiClient from "../api/client";
import { ENDPOINTS } from "../api/endpoints";

export const fetchOrders = async () => {
  const response = await apiClient.get(ENDPOINTS.orders);
  return response.data?.data || response.data || [];
};
